import React from 'react';
import { useShowContext } from 'framework/show';
import { Box, Grid2, Typography } from '@mui/material';
import BalancesLeavesField from './BalancesLeavesField';
import BalancesLeavesStatusField from './BalancesLeavesStatusField';
import NumberOfCalendarDaysField from './NumberOfCalendarDaysField';
import { MappedLeaveItem, ProcessedLeaveYear } from '../../shared/types';
import ViewDetailsButton from '../shared/ViewDetailsButton';
import { formatLeaveTypeWithSubType } from 'domain/people/leave/shared/leaveTypeDisplay';
import { Badge } from 'framework/ui/mui-builder';

interface PaidLeaveDetailsFieldProps {
  hideShowDetailsButtons?: boolean;
}

const PaidLeaveDetailsField: React.FC<PaidLeaveDetailsFieldProps> = ({ hideShowDetailsButtons = false }) => {
  const { data } = useShowContext<ProcessedLeaveYear>();
  const period = data?.getData();

  if (!period?.leaves?.length) return null;

  return (
    <Box mx={2} my={1} color="secondary">
      {period.leaves.map((leave: MappedLeaveItem, index: number) => (
        <Box color="secondary" key={leave.id ?? index}>
          <Grid2
            key={leave.id ?? index}
            container
            sx={{
              padding: '4px 0',
              alignItems: 'center',
              color: 'secondary.main',
            }}
          >
            <Grid2 size={4} pl={4}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center', flexWrap: 'wrap' }}>
                  <Box
                    sx={{
                      display: 'flex',
                      gap: 0.5,
                      flexWrap: { xs: 'wrap', sm: 'nowrap' },
                      mr: 2,
                    }}
                    mr={2}
                  >
                    <BalancesLeavesField source="startDate" value={leave} />
                    <span>-</span>
                    <BalancesLeavesField source="endDate" value={leave} />
                  </Box>
                  {leave?.takenFromPeriod && leave?.takenFromPeriod !== leave?.period?.duration && (
                    <Box>
                      <Badge color="primary">Composite</Badge>
                    </Box>
                  )}
                </Box>
                <Typography variant="body1" color="secondary">
                  {formatLeaveTypeWithSubType({
                    type: leave?.type ?? null,
                    subType: leave?.subType ?? null,
                    sickDayReason: leave?.sickDayReason ?? null,
                    leaveTypeFallback: !leave?.type ? (leave?.leaveType ?? null) : null,
                  })}
                </Typography>
              </Box>
            </Grid2>
            <Grid2 size={2}>
              <NumberOfCalendarDaysField value={leave} />
            </Grid2>
            <Grid2 size={3.5}>
              <BalancesLeavesStatusField value={leave} />
            </Grid2>
            <Grid2 size={2}> {!hideShowDetailsButtons && <ViewDetailsButton leaveId={leave.id ?? index} />} </Grid2>
          </Grid2>
        </Box>
      ))}
    </Box>
  );
};

export default PaidLeaveDetailsField;
